export default __webpack_public_path__ + "static/Bm_EFTB_iMedical_Exclusion-0acd9b8a9731d07b803b5cc20c04c121.pdf";